import React, { useEffect, useState } from 'react'
import ProfileInfo from '../components/ProfileInfo/ProfileInfo'
import { Spin, notification } from 'antd'
import { connect, useDispatch, useSelector } from 'react-redux'
import { useLocation, Redirect } from 'react-router-dom'
import { NotificationManager } from 'react-notifications'
import {
    getProfile
} from '../store/profile/actions'

const Profile = (props) => {

    const dispatch = useDispatch()
    const location = useLocation();
    const { isEdit } = location.state || {};
    const user = useSelector((state) => state.profile.user.data)
    const publicUserId = new URLSearchParams(location.search).get("userId");
    const token = localStorage.getItem('h-access_token')

    useEffect(() => {
        if (!user && !publicUserId && token)
            props.getProfile()
    }, [])

    useEffect(() => {
        if(isEdit == 'success') {
            NotificationManager.success("All changes have been successfully saved.", "Notification", 5000)
        }
    }, [isEdit])

    if (!localStorage.getItem('h-access_token') && !publicUserId)
        return <Redirect to="/" />
    
    return (
        <div className='flex h-screen md-flex-wrap'>
            <ProfileInfo isEdit={isEdit} />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.profile.user,
    }
}

const mapDispachToProps = (dispatch) => ({
    getProfile: () => dispatch(getProfile()),
})

export default connect(mapStateToProps, mapDispachToProps)(Profile)